import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { ServicesService } from '../services/services.service';

 
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  public show:boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  isListDataEmpty =false;
  spinLoader = {
    filter : false,
    delete : []
  };

  showManage: boolean = false; // Hidden for now.
    isListData=true;
    isOnePage=false;
  constructor(private _services: ServicesService, private router: Router) { }

	// lists:any;
	
  ngOnInit() {
    this.getPageRequest();
  }

  fields=[
  	{
  		'field':'product_name',
  		'title':'Product Name',
  		'width':'40%',
  		'code':true,
  		'sort':true
		},
		{
  		'field':'created_at',
  		'title':'Create Date',
  		'width':'25%',
  		'code':false,
  		'sort':true
		},
		{
  		'field':'updated_at',
  		'title':'Modify Date',
  		'width':'25%',
  		'code':false,
  		'sort':true
		},
				
	]
	
  viewProduct(id){
    // let data={};
    // const token    = localStorage.getItem('userToken');
    // this._services.requestCreator(data, this.route,token).subscribe((result: any) => {
    //   this.listData = [];
    //   this._services.tempData = result.result;
    // })
	  this.router.navigate(['/product-component'],{ queryParams: { pdt: id}});
  }
    
  resetSearchField(){
    this.spinLoader['filter'] = true;
    this.searchFields=[''];
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }

	sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){
    this.spinLoader['filter'] = true;
    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
		};
		
    this.getPageRequest();
  }

  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  route:string;
  searchFields= [];
  pages: any;
  listData = [];
  editData: Object = {};

  previousPage(){
    if(this.currentPage == 1){
      return;
    }
    this.currentPage = this.currentPage -1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();

  }

  nextPage() {

    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage(){

    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  totalData:any;
  getPageRequest(){

    this.route  = 'get-product-list';
    ////console.log(this.route);return;

    switch(this.route){

      case 'get-product-list' :{
        var data = {
          page  : this.currentPage,
          search: {
            'product_name' : this.searchFields['product_name']
          },
          sort  : this.sortingData
        };
      }
        break;
    }

    ////console.log(this.route);
    ////console.log(data);

			const token    = localStorage.getItem('userToken');
			this._services.requestCreator(data, this.route, token).subscribe((result: any) => {
      
        this.spinLoader['filter'] = false;
        this.isListData=false;

        this.listData = [];
        this.listData = result.result;
        this.totalData = result.paginate.total;

        this.currentPage = result.paginate.current_page;
        if(this.listData.length === 0){
          this.isListDataEmpty =true;
        }
        else{
          this.isListDataEmpty =false;
        }
        if(result.paginate.current_page > result.paginate.last_page){
          this.currentPage = result.paginate.last_page;
      }

      this.getPages(this.paginate.last_page);

      for (let key in this.spinLoader) {
        if(key == 'delete'){
          /*
            for (let deleteKey in this.spinLoader.delete) {
              this.spinLoader[key][deleteKey] = false;
            }
          */
          this.spinLoader[key] = [];
        }else{
          this.spinLoader[key] = false;
        }

      }
    });
    return true;
  }

	


}
